import {renderNotificationElement} from "../utils";
import {collapse} from "../../collapse";
import {getDeclension} from "../../utils/common";

const getNotificationTemplate = ({name, id, projectName, counts}) => {
  return `<li class="notifications__item js-collapse-${id}" data-n-task-id="${id}">
  <div tabindex="0" class="notifications__group js-collapse-btn">
    <span class="notifications__amount js-notifications-counts">+${counts} ${getDeclension(counts, [
    `событие`,
    `cобытия`,
    `событий`,
  ])}</span>
    <p class="notifications__task">${name}</p>
    <span class="notifications__project">${projectName}</span>
    <svg class="notifications__icon" width="8" height="12">
      <use xlink:href="/img/sprite.svg#icon-notify-arrow"></use>
    </svg>
  </div>
  <ul class="notifications__sublist js-collapse-block">
  </ul>
</li>`;
};

class TaskNotificationsList {
  private readonly taskData;
  private parent;
  private element;
  private isInitCollapseScript = false;
  private oneNotification = false;

  constructor(taskData, parent) {
    this.taskData = taskData;
    this.parent = parent;
  }

  updateCount(count) {
    this.taskData.counts = count;
  }

  updateCountElement() {
    if (!this.isOneNotification) {
      this.element.querySelector(`.js-notifications-counts`)
        .textContent = `+${this.taskData.counts} ${getDeclension(this.taskData.counts, [
        `событие`,
        `cобытия`,
        `событий`,
      ])}`;
    }
  }

  decreaseCount() {
    this.taskData.counts = this.taskData.counts - 1;
  }

  moveElementToNewDate() {
    const element = this.element.cloneNode(true);
    this.element.remove();
    this.parent.prepend(element);
    this.element = element;
    this.isInitCollapseScript = false;
  }

  renderElement() {
    if (!this.element) {
      this.element = renderNotificationElement(this.parent, getNotificationTemplate(this.taskData));
    }
  }

  initCollapseScript() {
    if (!this.isInitCollapseScript) {
      collapse({containerSelector: `.js-collapse-${this.taskData.id}`});
      this.isInitCollapseScript = true;
    }
  }

  removeElement() {
    if (!this.isOneNotification) {
      this.element.remove();
    }
  }

  getHtmlElementDate() {
    return this.element && this.element.closest(`[data-notification-date]`).dataset.notificationDate;
  }

  getCount() {
    return this.taskData.counts;
  }

  getElement() {
    return this.element;
  }

  getListElement() {
    return this.element.querySelector(`.js-collapse-block`);
  }

  setParent(parent) {
    this.parent = parent;
  }

  get isOneNotification() {
    return this.oneNotification;
  }

  set isOneNotification(value) {
    this.oneNotification = value;
  }
}

export default TaskNotificationsList;
